module.exports = __webpack_public_path__ + "img/Flash_on.d1234be3.svg";